export enum AlarmTypeGroupControl {
  CONTRACT_AND_SERVICE = 'CONTRACT_AND_SERVICE',
  OPERATIONAL_STATUS = 'OPERATIONAL_STATUS',
  COSTS_AND_CONDITION = 'COSTS_AND_CONDITION',
}
